import React from 'react'
import styled from '@emotion/styled'
import { string } from 'prop-types'

import { Link } from 'react-scroll'

// Styled Components via Emotion
const CardWrapper = styled.div`
	border: 1px solid #707070;
	height: auto;
	margin: auto;
	margin-bottom: 20px;
	width: 100%;

	${({ theme }) => theme.MQ.S} {
		width: calc(95% / 2);
		max-width: 385px;
		margin: 0 auto 2rem auto;
	}

	${({ theme }) => theme.MQ.L} {
		width: calc(95% / 3);
		margin: 0;
	}
`
const CardContent = styled.div`
	display: flex;
	flex-direction: column;
	height: 100%;
	margin: auto;
	padding: 35px 35px 66px 35px;
	text-align: left;
	width: auto;
`
const Title = styled.h3`
	${({ theme }) => theme.header.h3};
	display: block;
	color: ${({ theme }) => theme.colors.navy};
	font-size: 28px;
	line-height: 42px;
	margin: 0 0 24px;
	width: 100%;
`
const FeaturedTitle = styled.div`
	color: ${({ theme }) => theme.colors.navy};
	font-family: 'poppins medium', sans-serif;
	font-size: 16px;
	line-height: 25px;
	margin-bottom: 10px;
`
const Description = styled.div`
	display: block;
	color: ${({ theme }) => theme.colors.darkGrey};
	font-size: 16px;
	line-height: 25px;
	margin-bottom: 18px;

	${({ theme }) => theme.MQ.L} {
		font-size: 16px;
	}
`
const BulletPointContainer = styled.ul`
	margin: 0 0 2rem 0;
	padding: 0 0 0 28px;

	li {
		font-size: 16px;
		line-height: 25px;
		list-style: none;
		position: relative;
	}
	li:after {
		border-bottom: 3px solid ${({ theme }) => theme.colors.secondary};
		border-right: 3px solid ${({ theme }) => theme.colors.secondary};
		content: '';
		background-color: transparent;
		height: 11px;
		left: -23px;
		margin-top: 4px;
		position: absolute;
		top: 0px;
		transform: rotate(45deg);
		width: 5px;
	}
`
const ContactButton = styled(Link)`
	${({ theme }) => theme.buttons.default};
	bottom: 0;
	margin-top: auto;
	width: auto;
`

ShowcaseCard.propTypes = {
	description: string,
	image: string,
	title: string,
}

/**
 * This is the Showcase Product Card Component
 * Can be used to showcase any products/services we offer
 * takes in an image, title and description within the card
 * todo: make clickable if we want to add links in the future?
 */
function ShowcaseCard({ bulletPoints, description, image, title }) {
	return (
		<CardWrapper>
			<CardContent>
				<Title>{title}</Title>
				<Description dangerouslySetInnerHTML={{ __html: description }} />
				<FeaturedTitle>Features &amp; Benefits:</FeaturedTitle>
				<BulletPointContainer>
					{bulletPoints.map((bullet, i) => (
						<li key={i}>{bullet}</li>
					))}
				</BulletPointContainer>
				<ContactButton duration={700} offset={-100} smooth={true} to="pardot-form">
					Contact Us
				</ContactButton>
			</CardContent>
		</CardWrapper>
	)
}
export default ShowcaseCard
